import { useContext } from 'react';
import { ModalContext } from './ModalContext.context';
import type { ModalContextType } from './ModalContext';

/**
 * Hook para acceder al contexto del Modal
 * @throws Error si se usa fuera de un Modal
 */
export const useModalContext = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('Modal components must be used within a Modal');
  }
  return context;
};
